// Main entry file
import './styles/main.scss';
import '@/Features/Footer/Presentation/Footer/resources/front/styles/footer.scss';

import { init as initMotion } from './scripts/MotionHandler.js';

document.addEventListener('DOMContentLoaded', () => {
    const html = document.documentElement;

    html.classList.remove('no-js');
    html.classList.add('has-js');

    initMotion(html);
});
